"use client";

import { ErrorBoundary } from "react-error-boundary";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  ErrorBoundaryContainer,
  ErrorBoundaryContent,
  ErrorBoundaryTitle,
  ErrorBoundaryMessage,
  RefreshIconButton,
} from "styles/formStyleComponents";

function Fallback({ error, onReset }) {   
  return (
    <ErrorBoundaryContainer 
      severity="error" 
      role="alert"
      action={
        <Tooltip title="Retry">
          <RefreshIconButton
            aria-label="retry"
            size="small"
            onClick={onReset}
          >
            <RefreshIcon />
          </RefreshIconButton>
        </Tooltip>
      }
    >
      <ErrorBoundaryContent>
        <ErrorBoundaryTitle>
          Something went wrong
        </ErrorBoundaryTitle>
        <ErrorBoundaryMessage>
          {error || "An unexpected error occurred"}
        </ErrorBoundaryMessage>
      </ErrorBoundaryContent>
    </ErrorBoundaryContainer>
  );
}

export default function CustomErrorBoundary({ children, onReset, error }) {
  return (
    <ErrorBoundary
      FallbackComponent={Fallback}
      onReset={onReset}
      error={error}
    >
      {children}
    </ErrorBoundary>
  );
}

CustomErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  onReset: PropTypes.func,
  error: PropTypes.string,
};